export class BackgroundVerifyIdentityModel {
    Id: number = 0;
    FirstName: string;
    MiddleName: string;
    LastName: string;
    MobilePhoneNumber: any;
    EmailId = '';
    DateOfBirth: any;
    ConfirmedDateOfBirth: any;
    AddressNo1: string;
    ZipCode: string;
    City: string;
    States: string;
    SSN = '';
    SSN1 = '';
    SSN2 = '';
    SSN3 = '';
    ConfirmedSSN1 = '';
    ConfirmedSSN2 = '';
    ConfirmedSSN3 = '';
    ConfirmedSSN = '';
    EmailVerifiedOtp = '';
    PackageId: string;
    MessageVerifiedOtp = '';
    Password = '';
    ConfirmPassword = '';
}
